// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_Jmy","cls2":"NewsInteractionBar-cls2_L9- NewsInteractionBar-cls1_Jmy"};